import { create } from 'zustand';

interface KeyboardShortcutsDialogState {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export const useKeyboardShortcutsDialogStore = create<KeyboardShortcutsDialogState>((set) => ({
  open: false,
  setOpen: (open) => set({ open }),
}));
